import { render, staticRenderFns } from "./EditDescriptionDialog.vue?vue&type=template&id=7007fd20&scoped=true&"
import script from "@/views/Schedules/EditDescriptionDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Schedules/EditDescriptionDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Schedules/edit-description-dialog.scss?vue&type=style&index=0&id=7007fd20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7007fd20",
  null
  
)

export default component.exports